export const searchHighlight = {
  attrs: {
    class: { default: 'searchHighlight' }
  },
  parseDOM: [{ tag: `span.searchHighlight` }],
  toDOM: function (mark) {
    return ['span', mark.attrs]
  }
}
